import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import { respondToInvoice } from "../../actions/invoices";

export function InvoiceActionInstruction(props) {

const invoice = useSelector(state => state.invoices.invoice);

const instructions = {
    DR: "to complete this draft.",
    REV: "to review and approve or reject this digital invoice including any attached documents.",
    REJ: "to review the notes in the history below and cancel or revise and resend the invoice.",
    RED: "to review the notes in the history below and cancel or revise and resend the invoice.",
    CA: "",
    PR: "to pay the vendor, and confirm when the payment has been made.",
    PU: "to close this invoice by confirming that payment has been received in full.",
    PC: "This invoice is successfully closed.",
    AI: "to proceed with adjudication, then close the invoice once adjudication is complete and payment (if deemed required) has been received.",
    AC: "This invoice was closed following adjudication.",
}



    return (
        <div className="content2 light-black multiline" style={{whiteSpace: "pre-wrap"}}>
            {instructions[invoice.stage]}
        </div>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(InvoiceActionInstruction);

